import React from "react";
import { ThemeProvider, useTheme } from "styled-components";
import { getColors } from "../../../common/parameters";
import { IColorPalette } from "../../store/user/models";
import { useUser } from "../../store/user/selectors";
import { IProps } from "./interfaces";

const ColorsProvider = ({ children }: IProps) => {
    const { colors = 1 } = useUser();
    const theme = useTheme();
    return (
        <ThemeProvider
            theme={{
                ...theme,
                c: {
                    ...theme.c,
                    score: "#000000",
                    solfa: getColors(colors as number | IColorPalette),
                },
            }}
        >
            {children}
        </ThemeProvider>
    )
};

export default ColorsProvider;
